import { useEffect, useState } from "react";
import elements from "./json/elements.json";
import { CheckIcon } from "../../shuffle.dev/app - Copie/node_modules/@heroicons/react/outline";

export default function App() {
  const [sidebar, setSidebar] = useState(true);
  const [elementSelected, setElementSelected] = useState(null);
  const [variantDropdown, setVariantDropdown] = useState(false);
  const [variantSelected, setVariantSelected] = useState("");
  const [home, setHome] = useState(false);
  const [bg, setBg] = useState(null);
  const [icons, setIcons] = useState(null);
  const [librariesJson, setLibrariesJson] = useState(null);
  const [selection, setSelection] = useState(["tailwind", "atis"]);
  const [loading, setLoading] = useState(true);

  var dropdownButtons = [];

  function importAll(r) {
    let images = {};
    // eslint-disable-next-line array-callback-return
    r.keys().map((item) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  }

  function importAllJson(context) {
    const all = {};
    context.keys().forEach((item) => {
      const fileName = item.replace("./", "");
      const resource = require(`./json/${fileName}`);
      const namespace = fileName.replace(".json", "");
      all[namespace] = JSON.parse(JSON.stringify(resource));
    });
    setLoading(false);
    return all;
  }

  useEffect(() => {
    const fetchAssets = async () => {
      setBg(importAll(require.context("./bg/", false, /\.(png|jpe?g|svg)$/)));
      setIcons(
        importAll(require.context("./icons/", false, /\.(png|jpe?g|svg)$/))
      );
      setLibrariesJson(
        importAllJson(require.context("./json", true, /.json$/))
      );
    };
    fetchAssets();
  }, []);

  if (loading === false) {
    return (
      <div
        className={`flex flex-col mx-auto w-full min-h-screen bg-gray-100 ${
          sidebar ? "lg:pl-64" : ""
        }`}
      >
        <nav
          id="page-sidebar"
          className={`flex flex-col fixed top-0 left-0 bottom-0 w-full lg:w-64 h-full bg-sidebar-dark text-gray-200 z-50 transform transition-transform duration-500 ease-out ${
            sidebar ? "translate-x-0" : "-translate-x-full"
          }`}
          aria-label="Main Sidebar Navigation"
        >
          <div className="h-16 bg-gray-600 bg-opacity-25 flex-none flex items-center justify-between lg:justify-center px-4 w-full">
            <a
              href="shuffle"
              className="inline-flex items-center space-x-2 font-bold text-lg tracking-wide text-white-600 hover:text-white-400 text-white hover:opacity-75"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="hi-solid hi-cube-transparent inline-block w-5 h-5 text-orange-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                />
              </svg>
              <span>Shuffle</span>
            </a>

            <div className="lg:hidden">
              <button
                type="button"
                onClick={() => setSidebar(false)}
                className="inline-flex justify-center items-center space-x-2 border font-semibold focus:outline-none px-3 py-2 leading-5 text-sm rounded border-transparent text-white opacity-75 hover:opacity-100 focus:ring focus:ring-gray-500 focus:ring-opacity-25 active:opacity-75"
              >
                <svg
                  className="hi-solid hi-x inline-block w-4 h-4 -mx-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="overflow-y-auto">
            <div className="p-4 w-full">
              <nav className="space-y-1">
                <a
                  href="#"
                  onClick={() => setHome(false)}
                  className="flex items-center space-x-3 px-3 font-medium rounded text-gray-200 bg-gray-800 bg-opacity-50"
                >
                  <span className="flex-none flex items-center opacity-50">
                    <svg
                      className="hi-outline hi-home inline-block w-5 h-5"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                  </span>
                  <span className="py-2 flex-grow">
                    {selection[1][0].toUpperCase() + selection[1].substring(1)}
                  </span>
                  <span className="px-2 py-1 rounded-full text-xs font-medium leading-4 bg-opacity-10 text-gray-100 bg-gray-400">
                    {elements.shuffle[selection[0]][selection[1]].total}
                  </span>
                </a>
                {/*config file */}
                <a
                  href={"config/"+selection[0]+"_"+selection[1]+".zip"}
                  download
                  className="flex items-center space-x-3 px-3 font-medium rounded text-gray-200"
                >
                  <span className="flex-none flex items-center opacity-50">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                      />
                    </svg>
                  </span>
                  <span className="py-2 flex-grow">Config files</span>
                </a>

                {Object.keys(
                  elements.shuffle[selection[0]][selection[1]].elements
                ).map((item, itemIdx) => {
                  return (
                    <div>
                      <div className="px-3 pt-5 pb-2 text-xs font-medium uppercase tracking-wider text-gray-400">
                        {item}
                      </div>
                      {elements.shuffle[selection[0]][selection[1]].elements[
                        item
                      ].map((item, itemIdx) => {
                        return (
                          <a
                            onClick={() => {
                              setHome(true);
                              setElementSelected(item);
                            }}
                            href="#"
                            className="flex items-center space-x-3 px-3 font-medium rounded text-gray-300 hover:text-gray-100 hover:bg-gray-800 hover:bg-opacity-50 active:bg-gray-800 active:bg-opacity-25"
                          >
                            <span className="flex-none flex items-center opacity-50"></span>
                            <span className="py-2 flex-grow">{item}</span>
                            <span className="px-2 py-1 rounded-full text-xs font-medium leading-4 bg-opacity-10 text-gray-100 bg-gray-400">
                              {
                                elements.shuffle[selection[0]][selection[1]]
                                  .stats[item]
                              }
                            </span>
                          </a>
                        );
                      })}
                    </div>
                  );
                })}
              </nav>
            </div>
          </div>
        </nav>

        <header
          id="page-header"
          className={`flex flex-none items-center h-16 bg-white shadow-sm fixed top-0 right-0 left-0 z-30 ${
            sidebar ? "lg:pl-64" : ""
          }`}
        >
          <div className="flex justify-between max-w-10xl mx-auto px-4 lg:px-8 w-full">
            <div className="flex items-center space-x-2">
              <div className="hidden lg:block">
                <button
                  onClick={() => setSidebar(!sidebar)}
                  type="button"
                  className="inline-flex justify-center items-center space-x-2 border font-semibold focus:outline-none px-3 py-2 leading-6 rounded border-gray-300 bg-white text-gray-800 shadow-sm hover:text-gray-800 hover:bg-gray-100 hover:border-gray-300 hover:shadow focus:ring focus:ring-gray-500 focus:ring-opacity-25 active:bg-white active:border-white active:shadow-none"
                >
                  <svg
                    className="hi-solid hi-menu-alt-1 inline-block w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>

              <div className="lg:hidden">
                <button
                  type="button"
                  onClick={() => setSidebar(!sidebar)}
                  className="inline-flex justify-center items-center space-x-2 border font-semibold focus:outline-none px-3 py-2 leading-6 rounded border-gray-300 bg-white text-gray-800 shadow-sm hover:text-gray-800 hover:bg-gray-100 hover:border-gray-300 hover:shadow focus:ring focus:ring-gray-500 focus:ring-opacity-25 active:bg-white active:border-white active:shadow-none"
                >
                  <svg
                    className="hi-solid hi-menu-alt-1 inline-block w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </header>
        <main
          id="page-content"
          className="flex flex-auto flex-col max-w-full pt-16"
        >
          {home ? (
            <div className="max-w-10xl mx-auto p-4 lg:p-8 w-full">
              <nav className="mb-5">
                <ol class="flex items-center">
                  <li>
                    <a
                      href="javascript:void(0)"
                      class="text-orange-600 hover:text-orange-400"
                    >
                      {selection[0][0].toUpperCase() +
                        selection[0].substring(1)}
                    </a>
                  </li>
                  <li class="px-2 sm:px-3 opacity-50">
                    <svg
                      class="hi-outline hi-chevron-right inline-block w-6 h-6"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0)"
                      class="text-orange-600 hover:text-orange-400"
                    >
                      {selection[1][0].toUpperCase() +
                        selection[1].substring(1)}
                    </a>
                  </li>
                  <li class="px-2 sm:px-3 opacity-50">
                    <svg
                      class="hi-outline hi-chevron-right inline-block w-6 h-6"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </li>
                  <li>{elementSelected}</li>
                </ol>
              </nav>

              <div
                class={`relative inline-block mb-3 ${
                  selection[1] === "atis" ? "" : "hidden"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setVariantDropdown(!variantDropdown)}
                  class="inline-flex justify-center items-center space-x-2 border font-semibold focus:outline-none px-3 py-2 leading-5 text-sm rounded border-orange-700 bg-orange-500 text-white hover:text-white hover:bg-orange-600 hover:border-orange-600 focus:ring focus:ring-orange-500 focus:ring-opacity-50 active:bg-orange-700 active:border-orange-700"
                  id="tk-dropdown-simple"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  <span>Choose a variant</span>
                  <svg
                    class="hi-solid hi-chevron-down inline-block w-5 h-5 opacity-50"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <div
                  role="menu"
                  aria-labelledby="tk-dropdown-simple"
                  class={`absolute left-0 origin-top-left mt-2 w-48 shadow-xl rounded z-1 ${
                    variantDropdown
                      ? "transition ease-out duration-150"
                      : "hidden transition ease-in duration-100"
                  }`}
                >
                  <div class="bg-white ring-1 ring-black ring-opacity-5 rounded divide-y divide-gray-100">
                    <div class="p-2 space-y-1">
                      {Object.keys(
                        librariesJson[selection[0] + "_" + selection[1]]
                          .components
                      )
                        .reverse()
                        .map((item) => {
                          if (
                            item.split("(")[0] === elementSelected ||
                            item.split("(")[0] === elementSelected + " "
                          ) {
                            if (
                              item.split("(")[0] !==
                              variantSelected.split("(")[0]
                            ) {
                              setVariantSelected(item);
                            }
                            dropdownButtons.push(
                              <button
                                role="menuitem"
                                onClick={() => {
                                  setVariantSelected(item);
                                  setVariantDropdown(!variantDropdown);
                                }}
                                class="flex items-center space-x-2 rounded py-2 px-3 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:bg-gray-100 focus:text-gray-700"
                              >
                                <span>{item}</span>
                              </button>
                            );
                          }
                        })}
                      {dropdownButtons.reverse()}
                    </div>
                  </div>
                </div>
              </div>

              <div
                data-section-id="1"
                data-category="ta-alert-primary"
                data-component-id="c6588009_01_awz"
                class="py-8 px-6"
              >
                <div class="p-6 bg-indigo-50 border-l-4 border-indigo-500 rounded-r-lg">
                  <div class="flex items-center">
                    <h3
                      class="text-indigo-800 font-medium"
                      data-config-id="header"
                    >
                      If when you use one of the components below and it does
                      not appear as in the image, add{" "}
                      <code className="text-black">https://shuffle.dev</code> in
                      front of the resources in the source code of the
                      component.
                    </h3>
                  </div>
                </div>
              </div>

              {librariesJson[selection[0] + "_" + selection[1]].components[
                variantSelected
              ] != null
                ? librariesJson[selection[0] + "_" + selection[1]].components[
                    variantSelected
                  ].map((items) => {
                    return (
                      <div class="flex flex-col rounded shadow-sm bg-white overflow-hidden mb-5">
                        <div class="py-4 px-5 lg:px-6 w-full bg-gray-50 sm:flex sm:justify-between sm:items-center">
                          <div class="text-center sm:text-left"></div>
                          <div class="mt-3 sm:mt-0 text-center sm:text-right">
                            <button
                              class="inline-flex justify-center items-center space-x-2 border font-semibold focus:outline-none px-3 py-2 leading-5 text-sm rounded border-orange-700 bg-orange-500 text-white hover:text-white hover:bg-orange-600 hover:border-orange-600 focus:ring focus:ring-orange-500 focus:ring-opacity-50 active:bg-orange-700 active:border-orange-700"
                              onClick={() => {
                                navigator.clipboard.writeText(items.code);
                              }}
                            >
                              <svg
                                class="hi-solid hi-clipboard-copy inline-block w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M8 2a1 1 0 000 2h2a1 1 0 100-2H8z" />
                                <path d="M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z" />
                              </svg>{" "}
                            </button>
                          </div>
                        </div>

                        <div class="p-5 lg:p-6 flex-grow w-full">
                          <img src={items.preview} alt={items.id} />
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          ) : (
            <div class="py-8 px-6">
              <div class="p-6 border-l-4 border-indigo-600 bg-indigo-500 rounded-r-lg">
                <div class="flex">
                  <div class="w-auto">
                    <span class="w-auto inline-block mr-2">
                      <svg
                        width="20"
                        height="20"
                        viewbox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM11 14C11 14.6 10.6 15 10 15C9.4 15 9 14.6 9 14V10C9 9.4 9.4 9 10 9C10.6 9 11 9.4 11 10V14ZM10 7C9.4 7 9 6.6 9 6C9 5.4 9.4 5 10 5C10.6 5 11 5.4 11 6C11 6.6 10.6 7 10 7Z"
                          fill="#D7D5F8"
                        ></path>
                      </svg>
                    </span>
                  </div>
                  <div class="w-full">
                    <div class="flex mb-2">
                      <h3
                        class="text-white font-medium"
                        data-config-id="header"
                      >
                        How to import the configuration files for each libraries
                      </h3>
                    </div>
                    <div class="pr-6">
                      <p class="text-sm text-indigo-50" data-config-id="desc">
                      When you use a component, its appearance may differ on the preview. To solve this problem, click on "configuration files" and browse the archive to configure your theme. For example with tailwind, in the archive go to <code>Shuffle {">"} src {">"} config {">"} tailwind.config.js</code>. You will also find every assets of the libraries.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {Object.keys(elements.shuffle).map((item, itemIdx) => {
              return (
                <div className="max-w-10xl mx-auto p-4 lg:p-8 w-full">
                  <h2 class="text-2xl font-bold py-2 border-b-2 border-gray-200 mb-4 lg:mb-8">
                    {item[0].toUpperCase() + item.substring(1)}
                  </h2>

                  <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {Object.keys(elements.shuffle[item]).map(
                      (items, itemIdx) => (
                        <li
                          key={items}
                          className="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200"
                        >
                          <img
                            className="rounded-t-lg"
                            alt="illustration"
                            src={bg[item + "_" + items + ".png"].default}
                          ></img>
                          <div className="w-full flex items-center justify-between p-6 space-x-6">
                            <div className="flex-1 truncate">
                              <div className="flex items-center space-x-3">
                                <h3 className="text-gray-900 text-sm font-medium truncate">
                                  {items[0].toUpperCase() + items.substring(1)}
                                </h3>
                              </div>
                            </div>
                            <img
                              className="w-15 h-15 p-2 bg-gray-900 rounded-full flex-shrink-0"
                              alt=""
                              src={icons[item + "_" + items + ".svg"].default}
                            />
                          </div>
                          <div>
                            <div className="-mt-px flex divide-x divide-gray-200">
                              <div className="-ml-px w-0 flex-1 flex">
                                <button
                                  onClick={() => {
                                    setSelection([item, items]);
                                  }}
                                  className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                                >
                                  <CheckIcon
                                    className="w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                  />
                                  <span className="ml-3">
                                    Select this library
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              );
            })}
            </div>
          )}
        </main>

        <footer
          id="page-footer"
          className="flex flex-none items-center bg-white"
        >
          <div className="text-center flex flex-col md:text-left md:flex-row md:justify-between text-sm max-w-10xl mx-auto px-4 lg:px-8 w-full">
            <div className="pb-4 pt-1 md:pt-4 inline-flex items-center justify-center">
              <span>Made with</span>
              <svg
                className="hi-solid hi-heart inline-block w-4 h-4 mx-1 text-red-600"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                  clipRule="evenodd"
                />
              </svg>
              <span>
                for{" "}
                <a
                  href="https://fb.com/manhtuanxxx"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-orange-600 hover:text-orange-400"
                >
                  KieuManhTuan
                </a>
              </span>
            </div>
          </div>
        </footer>
      </div>
    );
  } else {
    return null;
  }
}
